import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore"
import { getUid } from "./auth"

type NotificationType =
  | "contribution_request"
  | "contributor_added"
  | "contribution_request_accepted"
  | "contribution_request_declined"
export interface NotificationBase {
  id: string
  sender: string
  receiver: string
  timestamp: Timestamp
  read: boolean
  type: NotificationType
}

export interface ContributionRequest extends NotificationBase {
  inspection: string

  username: string
}

export type Notification = ContributionRequest

export function pushNotification(
  notification: Omit<Notification, "id" | "timestamp" | "read">,
) {
  const db = getFirestore()
  const timestamp = new Date()
  const read = false
  const document = doc(collection(db, `notifications`))

  return setDoc(document, { ...notification, timestamp, read })
}
export function notificationRead(id: string, update: Partial<Notification>) {
  const db = getFirestore()
  const document = doc(db, `notifications/${id}`)

  return updateDoc(document, { read: true, ...update })
}
export function onNotifications(fn: (notifications: Notification[]) => void) {
  const db = getFirestore()
  const uid = getUid()
  const w = [where("receiver", "==", uid), where("read", "==", false)]

  const q = query(collection(db, `notifications`), ...w)

  return onSnapshot(q, snapshots => {
    if (snapshots.empty) return fn([])
    console.log(snapshots.size)

    fn(
      snapshots.docs.map(
        snapshot => ({ ...snapshot.data(), id: snapshot.id }) as Notification,
      ),
    )
  })
}
